module.exports = __webpack_public_path__ + "static/media/trampoline.7d8b346f.webp";